/**
 * Type definitions for Groups Management components
 */

// ============================================================================
// State Interfaces
// ============================================================================

export interface BulkGroupItem {
    id: string;
    displayName: string;
    legacyFilter?: string;
    convertedFilter?: string;
    optimizedFilter?: string;
    hasSet?: boolean;
    filterMatch?: string;
    filterScope?: string;
    member?: any[];
    nameMatch?: boolean;
    nameWarning?: string;
    attributeWarning?: string[];
    isManaged?: boolean;
    filterTestWarning?: string;
    filterTestGroupCount?: number;
    needsFilterUpdate?: boolean;
    existingFilterCount?: number;
    optimizedFilterCount?: number;
    _loading?: {
        converted?: boolean;
        optimized?: boolean;
        counts?: boolean;
    };
}

export interface ProcessingStats {
    processingTimeMs: number | null;
    itemsProcessed: number;
    itemsNotInCache: number;
}

export interface ConversionStats {
    conversionTimeMs: number | null;
    itemsConverted: number;
}

export type BulkGroupStatus = {
    status: 'pending' | 'processing' | 'success' | 'error' | 'warning';
    message?: string;
};

export interface FilterTestCache {
    count?: number;
    error?: string;
}

// ============================================================================
// Constants
// ============================================================================

export const ITEMS_PER_PAGE = 25;

